<hvl-form-item [formGroup]="formGroup" label="{{ label | translate }}" key="{{ name }}">
    <input pInputText [disabled]="disabled" [id]="inputId" [name]="name" [formControlName]="name" [type]="type" />
</hvl-form-item>
